import React from "react";
import { QRCodeCanvas } from "qrcode.react"; // QRCodeCanvasをインポート

const QRCodeGenerator = ({ link }) => {
  // "MN_"を先頭に追加
  const value = `MN-${link}`;

  return <QRCodeCanvas value={value} size={224} />;
};

export default QRCodeGenerator;
